import { Box, Center, HStack, Text, VStack } from '@chakra-ui/react';
import { MapCustomScrollbar } from '@components/common/layout/MapCustomScrollbar';
import { DistanceUnits, formatUnit } from '@utils/unit.utils';
import { formatCoordinatesToString } from '@utils/validation/coordinates.utils';
import DmsCoordinates from 'dms-conversion';
import { Position } from 'geojson';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { CoordinatesUnitEnum } from '@/types/commons/commons.types';

type Props = {
  mapboxPoints: Position[];
  unit: CoordinatesUnitEnum;
  height: number | null;
  isLowerLevel?: boolean;
};

function ZonePointsGrid({ mapboxPoints, unit, height }: Readonly<Props>) {
  if (height == null) {
    // should not happen
    return (
      <Box width="100%" height="192px" backgroundColor="neutral.900" paddingY={1} flexGrow={1}>
        <FormattedMessage id="error.common.unknown_error" />
      </Box>
    );
  }

  const heightNumber = parseInt(height.toString()); //Pour éviter un crash. Formik envoie "" quand l'input est vide
  return (
    <Box width="100%" height="192px" backgroundColor="neutral.900" paddingY={1} flexGrow={1}>
      <MapCustomScrollbar margin={1} height="100%" marginTop={0} marginBottom={0} thumbColor="neutral.600">
        <VStack gap={1.5} height="100%" width="100%" paddingLeft={2}>
          {mapboxPoints.slice(0, mapboxPoints.length - 1).map((point, index) => {
            return (
              <HStack
                key={`${index + 1}`}
                gap={2}
                width="100%"
                paddingRight={3}
                paddingTop={index === 0 ? 1 : 0}
                paddingBottom={index === mapboxPoints.length - 1 ? 1 : 0}
              >
                <Center width="30px">
                  <Text
                    textStyle="md"
                    fontWeight="medium"
                    border="2px solid"
                    borderColor="neutral.white"
                    height="24px"
                    paddingX="3px"
                  >{`${index + 1}`}</Text>
                </Center>
                <Text width="340px" lineClamp={1} textStyle="md" fontWeight="medium">
                  {formatCoordinatesToString(new DmsCoordinates(point[1], point[0]), unit)}
                </Text>
                <Text textStyle="md" fontWeight="medium">
                  {formatUnit(DistanceUnits.METERS, !Number.isNaN(heightNumber) ? heightNumber : null)}
                </Text>
              </HStack>
            );
          })}
        </VStack>
      </MapCustomScrollbar>
    </Box>
  );
}

export default ZonePointsGrid;
